import { Link } from "react-router-dom";
import { featuredComics } from "@/mocks/comics";

export default function FeaturedSection() {
  return (
    <section className="w-full bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              编辑推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1 font-label">
              精选优质韩漫，品质保证
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex gap-4 p-4 rounded-lg bg-background-50 hover:bg-primary-50/30 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="w-24 h-32 md:w-28 md:h-36 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-base font-semibold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 font-label">
                    {comic.author}
                  </p>
                  <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
                    {comic.description}
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-3 flex-wrap">
                  <span className="text-xs text-accent-600 font-label">
                    <i className="ri-star-fill text-xs mr-0.5"></i>
                    {comic.rating}
                  </span>
                  <span className="text-xs text-foreground-400 font-label">
                    {(comic.views / 10000).toFixed(0)}万人气
                  </span>
                  <span className="text-xs text-foreground-400 font-label">
                    {comic.chapters}话
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}